export const ADMIN_CREATE_BLOGCATEGORY_REQUEST = "ADMIN_CREATE_BLOGCATEGORY_REQUEST";
export const ADMIN_CREATE_BLOGCATEGORY_SUCCESS = "ADMIN_CREATE_BLOGCATEGORY_SUCCESS";
export const ADMIN_CREATE_BLOGCATEGORY_FAIL = "ADMIN_CREATE_BLOGCATEGORY_FAIL";

export const ADMIN_VIEW_BLOGCATEGORY_REQUEST = "ADMIN_VIEW_BLOGCATEGORY_REQUEST";
export const ADMIN_VIEW_BLOGCATEGORY_SUCCESS = "ADMIN_VIEW_BLOGCATEGORY_SUCCESS";
export const ADMIN_VIEW_BLOGCATEGORY_FAIL = "ADMIN_VIEW_BLOGCATEGORY_FAIL";

export const ADMIN_LIST_BLOGCATEGORY_REQUEST = "ADMIN_LIST_BLOGCATEGORY_REQUEST";
export const ADMIN_LIST_BLOGCATEGORY_SUCCESS = "ADMIN_LIST_BLOGCATEGORY_SUCCESS";
export const ADMIN_LIST_BLOGCATEGORY_FAIL = "ADMIN_LIST_BLOGCATEGORY_FAIL";

export const ADMIN_REMOVE_BLOGCATEGORY_REQUEST = "ADMIN_REMOVE_BLOGCATEGORY_REQUEST";
export const ADMIN_REMOVE_BLOGCATEGORY_SUCCESS = "ADMIN_REMOVE_BLOGCATEGORY_SUCCESS";
export const ADMIN_REMOVE_BLOGCATEGORY_FAIL = "ADMIN_REMOVE_BLOGCATEGORY_FAIL";

export const ADMIN_UPDATE_BLOGCATEGORY_REQUEST = "ADMIN_UPDATE_BLOGCATEGORY_REQUEST";
export const ADMIN_UPDATE_BLOGCATEGORY_SUCCESS = "ADMIN_UPDATE_BLOGCATEGORY_SUCCESS";
export const ADMIN_UPDATE_BLOGCATEGORY_FAIL = "ADMIN_UPDATE_BLOGCATEGORY_FAIL";
